import { ButtonPrimary } from "c4u-web-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { paths } from "../../../constants";
import { ContentOrganism } from "./../../organisms";

export const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      {t("Hooooome")}
      <ContentOrganism title={t("TitleContentOrganism")} />
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          gap: "20px",
          margin: "60px 0",
        }}
      >
        <div>Ir para:</div>
        <div style={{ width: "176px" }}>
          <ButtonPrimary
            sizex={"md"}
            onClick={() => history.push(paths.myQuotes())}
          >
            {"Minhas Cotações"}
          </ButtonPrimary>
        </div>
        <div style={{ width: "176px" }}>
          <ButtonPrimary
            sizex={"md"}
            onClick={() =>
              history.push(paths.finalData("publicPersonId", "encodeLenderCode"))
              // history.push(paths.finalData("Z-cpFQVT1VXvG7STZ_hmdSpO", "REFZQ09WQUw="))
            }
          >
            {"Dados Finais"}
          </ButtonPrimary>
        </div>
        <div style={{ width: "176px" }}>
          <ButtonPrimary
            sizex={"md"}
            onClick={() => history.push(paths.quotes())}
          >
            {"Cotações"}
          </ButtonPrimary>
        </div>
        <div style={{ width: "176px" }}>
          <ButtonPrimary
            sizex={"md"}
            onClick={() => history.push(paths.payment())}
          >
            {"Pagamento"}
          </ButtonPrimary>
        </div>
      </div>
    </>
  );
};
